import { useEffect } from "react";
import { useRegion } from "@/hooks/useRegion";

export const RegionProvider = ({ children }: { children: React.ReactNode }) => {
  const { region } = useRegion();

  useEffect(() => {
    // Add region class to body for CSS targeting
    document.body.setAttribute("data-region", region);
    document.documentElement.setAttribute("data-region", region);

    return () => {
      document.body.removeAttribute("data-region");
      document.documentElement.removeAttribute("data-region");
    };
  }, [region]);

  return <>{children}</>;
};
